import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';

import { HOUR_TO_MILLISECONDS_FACTOR } from './constants';

export const hoursToMilliseconds = (hours: number | null | undefined) => {
  if (isUndefinedOrNull(hours)) {
    return undefined;
  }

  return hours * HOUR_TO_MILLISECONDS_FACTOR;
};
